import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router/index";
import store from "./store/index";
import "./router/permit";
import "./assets/styles/common.scss";
import directive from "@/common/directive";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/styles/element-ui.scss";
import * as https from "./api/index";
import { RouterLinkStub } from "@vue/test-utils";
import "normalize.css/normalize.css";
import "./assets/styles/public/reset.scss";
import ElementUI from "element-ui";
import rootConsole from "@/mixins/rootConsole";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import config from "@/config";
import { getAreaOption, getCity, getAreaProps } from "./common/preLoad";
import { logConfig, logErr } from "./common/log";
import * as $echarts from "echarts";
// quill styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

// @ts-ignore
import scroll from "vue-seamless-scroll";
Vue.use(scroll)
// const compList = [ Container, Header, Aside, Menu, Submenu, MenuItem, MenuItemGroup, MessageBox, Main, Footer, Tabs, TabPane, Table, TableColumn, Button, Input, ButtonGroup, Pagination, Message, Select, Option, DatePicker, Dialog, Cascader, Radio, RadioGroup, RadioButton, Form, FormItem, Carousel, CarouselItem, InputNumber, Autocomplete, Dropdown, DropdownMenu, DropdownItem, Loading, Upload, Popover,]
// compList.forEach((item: any) => {
//   import { item } from "element-ui";
// })
const mainBaseURL = "/api";

Vue.prototype.mainBaseURL = mainBaseURL;
// 全局方法挂载
Vue.prototype.resetForm = function(refName: any) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
};
Vue.prototype.resetFiles = function(refName: any) {
  if (this.$refs[refName]) {
    this.$refs[refName].clearFiles();
  }
};
Vue.prototype.selectDictLabel = function(datas: any, value: any) {
  var actions: any = [];
  Object.keys(datas).some((key) => {
    if (datas[key].dictCode == "" + value) {
      actions.push(datas[key].dictName);
      return true;
    }
  });
  return actions.join("");
};
Vue.prototype.applicationTypeData = function(
  data: any,
  val: any,
  dictLabel: any,
  dictValue: any
) {
  dictLabel = dictLabel || "dictLabel";
  dictValue = dictValue || "dictValue";
  if (val !== undefined) {
    const cloneData = data.filter((father: any) => {
      return father[dictValue] === val;
    });
    return cloneData[0][dictLabel];
  }
};
Vue.prototype.parseTime = function(time: any, pattern: any) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = pattern || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    } else if (typeof time === "string") {
      time = time.replace(new RegExp(/-/gm), "/");
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj: any = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(
    /{(y|m|d|h|i|s|a)+}/g,
    (result: any, key: any) => {
      let value: any = formatObj[key];
      // Note: getDay() returns 0 on Sunday
      if (key === "a") {
        return ["日", "一", "二", "三", "四", "五", "六"][value];
      }
      if (result.length > 0 && value < 10) {
        value = "0" + value;
      }
      return value || 0;
    }
  );
  return time_str;
};

Vue.prototype.handleView = function(file: any) {
  if (file.url !== undefined) {
    window.open(file.url, "_blank");
    return false;
  }

  if (file.response !== undefined && file.response.data.url !== undefined) {
    window.open(file.response.data.url, "_blank");
    return false;
  }
};
Vue.prototype.beforeUploadZjtx = function beforeUploadZjtx(
  file: any,
  fileList: any
) {
  let suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
  if (suffix != "pdf" && suffix != "doc" && suffix != "docx") {
    this.msgError("只能上传pdf/doc/docx格式的文件");
    return false;
  }
  if (file.size > 10240000) {
    this.msgError("文件最大可上传10MB,您上传的" + file.name + "已超出限制");
    return false;
  }
};
Vue.prototype.inputMax = 50;
Vue.prototype.emailMax = 20;
Vue.prototype.nameMax = 10;

// 上传的图片服务器地址
(Vue.prototype.uploadImgUrl = mainBaseURL + "/common/file/upload"),
  //员工导入地址
  (Vue.prototype.employeeImportUrl =
    mainBaseURL + "/importDate/importEmployees"),
  (Vue.prototype.msgSuccess = function(msg: any) {
    this.$message({ showClose: true, message: msg, type: "success" });
  });

Vue.prototype.msgError = function(msg: any) {
  this.$message({ showClose: true, message: msg, type: "error" });
};
Vue.config.devtools = true;
Vue.prototype.$loading = ElementUI.Loading.service;
Vue.prototype.$message = ElementUI.Message;
Vue.prototype.$confirm = ElementUI.MessageBox.confirm;
Vue.prototype.$prompt = ElementUI.MessageBox.prompt;
Vue.prototype.$alert = ElementUI.MessageBox.alert;
Vue.prototype.$https = https;
Vue.prototype.$echarts = $echarts;
Vue.config.productionTip = false;
Vue.use(ElementUI);
config.reportRoot && Vue.mixin(rootConsole);
Vue.directive("enterNextInput", {
  inserted: function(el) {
    el.addEventListener("keypress", function(e) {
      e = e || window.event;
      const charCode = typeof e.charCode == "number" ? e.charCode : e.keyCode;

      if (charCode === 13) {
        const dom = document.getElementsByTagName("input");

        for (let i = 0; i < dom.length; i++) {
          if (dom[i] === document.activeElement) {
            if (i === dom.length) {
              return;
            }
            dom[i + 1].focus();
            return;
          }
        }
      }
    });
  },
});
Vue.config.productionTip = false;
async function init() {
  const { main, center } = await getAreaOption();
  const city = await getCity(main);
  const allArea = main;
  new Vue({
    el: "#app",
    name: "root",
    data() {
      return {
        currentAreaProps: {},
        filterAreaOption: main,
        centerAreaOption: center,
        areaOption: allArea,
        directCityList: ["110100", "120100", "310100", "500100"],
        directProvinceList: ["110000", "120000", "310000", "500000"],
      };
    },
    computed: {
      ...mapGetters(["cityId"]),
    },
    methods: {
      ...mapActions(["getAreaOption"]),
      ...mapMutations(["setCity"]),
      setDefaultCity() {
        this.setCity(city);
      },
      setDefaultAreaProps() {},
      setBuriedPoint() {
        this.$nextTick(() => {
          const SITE_ID = 1279882605;
          const script: any = document.createElement("script");
          script.src = `https://v1.cnzz.com/z_stat.php?id=${SITE_ID}&web_id=${SITE_ID}`;
          script.language = "JavaScript";
          script.id = "cnzz";
          document.body.appendChild(script);
        });
      },
    },
    async mounted() {
      this.setDefaultCity();
      this.setBuriedPoint();
    },
    watch: {
      cityId: {
        handler(newValue, oldValue) {
          const props: any = getAreaProps(allArea, newValue);
          props.centerId = center.value;
          props.centerName = "国家";
          this.currentAreaProps = props;
        },
        immediate: true,
      },
    },
    router,
    store,
    // template: `<div id="app">123</div>`,
    template: `<div id="app"><RouterView /></div>`,
  });
}
init();
